// src/dataProvider.js

import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils } from 'react-admin';
import { API_URL } from './config'; // <-- **الإضافة الجديدة**: استيراد الرابط المركزي

/**
 * A custom httpClient that attaches the JWT token to every API request.
 */
const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
};

/**
 * Initialize the dataProvider with the API URL and the custom httpClient.
 * All data requests made by React Admin will now go through this central point.
 */
const baseDataProvider = simpleRestProvider(
    `${API_URL}/admin`,
    httpClient
);

const dataProvider = {
    ...baseDataProvider,
    getList: (resource, params) => {
        // هذه الدالة ستتعامل مع كل طلبات القوائم
        return baseDataProvider.getList(resource, params).then(response => {
            // react-admin يتطلب أن يكون لكل عنصر id
            // الكود التالي يضمن أن كل عنصر له id حتى لو لم يكن موجودًا في الأصل
            const dataWithId = response.data.map(item => ({
                ...item,
                id: item.id || item.originalId || item._id, // استخدم أي حقل فريد كـ id
            }));
            return {
                data: dataWithId,
                total: response.total,
            };
        });
    },
};

export default dataProvider;